<div class="panel-header">
  <!-- <div class="header pt-4 text-center">
    <img class="logo-header" src="./assets/img/logos/skylark-control-logo-white.svg" alt="Skylark Dashboard"/>
  </div> -->
</div>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card certificate-approval-page">
        <div class="row">
          <div *ngIf="tabitems && tabitems.length" class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div [class]="tabitems && tabitems.length ? 'col-md-10' : 'col-md-12'">
            <div *ngIf="workflowItem" class="certificate-approval-content mb-2 animated fadeIn">
              <div class="certificate-approval-title">
                <i class="far fa-edit"></i>
                <h3 class="mb-0">{{ title }}</h3>
              </div>

              <div class="certificate-approval-meta">
                <h5 class="certificate-approval-name mb-2">
                  Worker:
                  <a
                    *ngIf="canOpenWorkerCompetencyLink; else plainWorkerName"
                    [routerLink]="workerCompetencyLink"
                    [queryParams]="workerCompetencyLinkQueryParams"
                    style="color: inherit; text-decoration: underline;">
                    <strong>{{ workerWorkflowItem.workerName }}</strong>
                  </a>
                  <ng-template #plainWorkerName>
                    <strong>{{ workerWorkflowItem.workerName }}</strong>
                  </ng-template>
                </h5>
              </div>

              <div class="certificate-approval-details">
                <h6>Details</h6>
                <ng-container *ngIf="workflowItem">
                  <div *ngIf="shouldShowSiteOwnerName" class="mb-2">
                    Site Operator:
                    <strong>{{ currentSiteOwnerName }}</strong>
                  </div>
                  Requested by:
                  <username-display
                    *ngIf="canOpenRequestedByDetails; else plainRequestedBy"
                    [userName]="workflowItem.createdBy">
                  </username-display>
                  <ng-template #plainRequestedBy>
                    <span>{{ workflowItem.createdBy }}</span>
                  </ng-template>
                  <div
                    *ngIf="workflowItem.status === 'DOCUMENT_REJECTED'"
                    class="mt-2">
                    Reason for Rejection:
                    <span>{{ workerWorkflowItem.competencyApprovalReason || 'No reason provided' }}</span>
                  </div>
                </ng-container>
              </div>

              <div *ngIf="isOwnCompetencyApproval" class="alert alert-info" role="alert">
                {{ selfApprovalMessage }}
              </div>

              <div *ngIf="isOutOfScopeViewOnly && !isOwnCompetencyApproval" class="alert alert-info" role="alert">
                {{ outOfScopeMessage }}
              </div>

              <p-table [value]="[workflowItem]" [autoLayout]="true" class="certificate-approval-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Type</th>
                    <th>Files</th>
                    <th>Expiry Date</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-comp>
                  <tr [pSelectableRow]="comp">
                    <td>{{ comp.competencyType }}</td>
                    <td>
                      <div *ngFor="let file of comp.files" class="certificate-file-row">
                        <span>{{ file.fileName }}</span>
                        <button type="button" class="btn btn-primary btn-round-action" (click)="viewDocument(file.fileName)">View File</button>
                      </div>
                    </td>
                    <td>{{ comp.expiryDate | date: 'MMM d, y' }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="3">No certificates found</td>
                  </tr>
                </ng-template>
              </p-table>

              <div class="certificate-approval-actions" *ngIf="!showRejectionForm && !showApprovalForm && !isViewOnly">
                <button type="submit" class="btn btn-success btn-round btn-round-action" [disabled]="saveInProgress" (click)="approve()">Approve</button>
                <button type="submit" class="btn btn-danger btn-round btn-round-action" [disabled]="saveInProgress" (click)="reject()">Reject</button>
              </div>

              <ng-container *ngIf="showApprovalForm && !isViewOnly">
                <div class="form-row certificate-approval-rejection-form mt-4">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Expiry Date <span class="required-text">(required)</span></label>
                      <p-calendar
                        class="form-control"
                        [(ngModel)]="approvalExpiryDate"
                        name="approvalExpiryDate"
                        required="required"
                        dateFormat="dd/mm/yy"
                        [yearNavigator]="true"
                        [yearRange]="approvalDatepickerYearRange"
                        [monthNavigator]="true"
                        [minDate]="today"
                        placeholder="Select Expiry Date"
                        [showIcon]="true"
                        panelStyleClass="popupBelowDate"
                        [style]="{ width: '100%' }">
                      </p-calendar>
                      <small class="text-danger" *ngIf="approvalExpiryDateRequired && !approvalExpiryDate">Expiry date is required.</small>
                      <small class="text-danger" *ngIf="isApprovalDateInPast">This submitted date is now in the past. Please choose a new future date or reject the submission.</small>
                    </div>
                  </div>
                </div>

                <div class="certificate-approval-actions">
                  <button
                    type="submit"
                    class="btn btn-success btn-round btn-round-action"
                    [disabled]="saveInProgress || approvalSubmitInProgress || !approvalExpiryDate || isApprovalDateInPast"
                    (click)="saveApproval()">
                    Approve
                  </button>
                  <button type="button" class="btn btn-link btn-link-cancel" [disabled]="saveInProgress" (click)="cancelApproval()">
                    <i class="fas fa-times"></i>
                    Cancel
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="showRejectionForm && !isViewOnly">
                <div class="certificate-approval-rejection-intro alert alert-warning" role="alert">
                  <p class="mb-0"><b>Let the Worker know why this was rejected</b></p>
                </div>

                <div class="form-row certificate-approval-rejection-form">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Reason for Rejection <span class="required-text">(required)</span></label>
                      <textarea
                        type="text"
                        class="form-control certificate-approval-rejection-textarea"
                        placeholder="Enter reason for competency rejection..."
                        maxlength="300"
                        [(ngModel)]="rejectionForm"></textarea>
                      <small class="form-text text-muted text-right">300 characters maximum</small>
                    </div>
                  </div>
                </div>
                <div class="certificate-approval-actions">
                  <button
                    type="submit"
                    class="btn btn-success btn-round btn-round-action"
                    [disabled]="saveInProgress || !(rejectionForm || '').trim()"
                    (click)="saveRejection()">Reject</button>
                  <button type="button" class="btn btn-link btn-link-cancel" [disabled]="saveInProgress" (click)="cancelRejection()">
                    <i class="fas fa-times"></i>
                    Cancel
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
